
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ActionDefinitionStore from '../../stores/ActionDefinitionStore';
import { ActionDefinition, ActionsApiUiClient, TriggerActionRequest } from '../backend/backendapi';
import { handleError, initClient } from '../../api';
import Spinner from '../util/Spinner';
import TriggerModalDutySpecific from './TriggerModal/TriggerModalDutySpecific';

@Component({
  components: {
    Spinner,
    TriggerModalDutySpecific, 
  },
})
export default class TriggerModal extends Vue {
  readonly store = new ActionDefinitionStore();
  private readonly api = initClient(ActionsApiUiClient);

  triggering: ActionDefinition | null = null;

  mounted(): void {
    this.store.reload();
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async trigger(definition: ActionDefinition): Promise<void> {
    this.triggering = definition;
    try {
      if (definition.type === 'duty.specific') {
        (this.$refs.dutySpecificModal as TriggerModalDutySpecific).open(definition);
      } else {
        await this.api.trigger(new TriggerActionRequest({ definitionId: definition.id }));
        this.$toasted.info(this.$t('actions.triggerModal.actionTriggered').toString());
      }
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.triggering = null;
    }
  }
}
